// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__19NWX","question":"Question_question__3WezH","description":"Question_description__1CeGh"};